import { forwardRef, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";

export const IndeterminateCheckbox = forwardRef(
	(
		{ indeterminate, toggleAllRowsSelected, toggleRowSelected, ...rest },
		ref
	) => {
		const defaultRef = useRef();
		const resolvedRef = ref || defaultRef;

		useEffect(() => {
			resolvedRef.current.indeterminate = indeterminate;
		}, [resolvedRef, indeterminate]);

		return (
			<Form.Check.Input
				data-testid="test-fieldCheckboxInput"
				type="checkbox"
				{...rest}
				onChange={(e) => {
					toggleAllRowsSelected && indeterminate
						? toggleAllRowsSelected(false)
						: toggleRowSelected
						? toggleRowSelected()
						: rest.onChange(e);
				}}
				onClick={(e) => e.stopPropagation()}
				ref={resolvedRef}
			/>
		);
	}
);

IndeterminateCheckbox.displayName = "IndeterminateCheckbox";

